import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ThemeState {
    isDarkMode: boolean;
    isProfessionalMode: boolean;
    isCustomCursorActive: boolean;
    toggleTheme: () => void;
    toggleProfessionalMode: () => void;
    toggleCustomCursor: () => void;
}

export const useThemeStore = create<ThemeState>()(
    persist(
        (set) => ({
            isDarkMode: false,
            isProfessionalMode: false,
            isCustomCursorActive: false,
            toggleTheme: () => set((state) => ({ isDarkMode: !state.isDarkMode })),
            toggleProfessionalMode: () => set((state) => {
                const newValue = !state.isProfessionalMode;
                return {
                    isProfessionalMode: newValue,
                    isCustomCursorActive: newValue ? state.isCustomCursorActive : false
                };
            }),
            toggleCustomCursor: () => set((state) => ({ isCustomCursorActive: !state.isCustomCursorActive })),
        }),
        {
            name: 'curecraft-theme',
        }
    )
);
